import Svg, { Circle, Ellipse } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SVGComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Circle cx={10} cy={10} r={10} fill={ds.colorValue.background.accent.indigo.strong} />
        <Ellipse cx={10} cy={10} rx={6} ry={3} stroke={props.color ?? ds.colorValue.icon.inverse} strokeWidth={2} />
    </Svg>
);
export { SVGComponent as CircleRescue };
